import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import Logo from "@/components/app/Logo";

export default function ProtectedRoute({ children, allowOnboarding = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" data-testid="loading-screen">
        <div className="text-center">
          <Logo size={56} showText className="text-3xl justify-center" />
          <div className="mt-3 font-body text-sm text-neutral-500">Loading...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Onboarding wall — new users with onboarding_complete=false must finish the
  // wizard before they can hit any other route. The wizard route itself sets
  // allowOnboarding=true so it can render.
  if (
    user.onboarding_complete === false &&
    !allowOnboarding &&
    location.pathname !== "/onboarding"
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
